module.exports = __webpack_public_path__ + "static/media/info-icon.ba51ae33.png";